import lottie from "lottie-web"
import basicThankYouAnimation from "../../animations/thank-you-animation.json"
import upsell from "../upsell"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell(),

  statusToTrack: "PURCHASE",
  isStoreDataChangedNeeded: true,
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.commonInit()

    lottie.loadAnimation({
      container: document.querySelector("#thankyou-animation"),
      animationData: basicThankYouAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })

    this.store.values.isUpsell = true
    if (this.store.values.lastPaymentMethod && this.store.values.lastPaymentMethod === "primer") {
      this.store.values.isCardSaved = true
    }
  },

  onInit() {
    this.store.savePurchasedBasicOffer()
  },

  redirectUserToNextPage() {
    window.location = nextStepPath
  },

  sendSentryError() {
    if (window && window.Sentry && window.Sentry.captureMessage) {
      try {
        window.Sentry.captureMessage("segmentUserId is not set")
      } catch (error) {
        console.error("Sentry error:", error)
      }
    } else {
      console.error("Window.Sentry is not available")
    }
  },

  handleButton() {
    if (!this.store.values.segmentUserId) {
      // Log error if segmentUserId is not set
      this.sendSentryError()
    }

    this.internalTracker.trackClick({ clickName: "Continue Clicked" })
    this.redirectUserToNextPage()
  },
})
